angular.module('wbServices').factory 'plans',

['$location', 'finance', 'feeSchedule', ($location, finance, feeSchedule) ->
  class Debt
    propeties =
      balance: 0
      interestRate: 0.03
      paymentsPerYear: 12
      payment: 0

    constructor: (data) ->
      _.extend(@, data)
      _.defaults(@, properties)

    realRate: =>
      finance.realRateOfReturn(@interestRate, @inflationRate)

    stringify: =>
      values = _.pick(@, _.keys(properties))
      JSON.stringify(values)

  class Plan
    properties =
      age: 35
      savings: 60000
      monthlyContribution: 500
      legacy: 0
      retirementAge: 65
      planEnd: 100
      interestRate: 0.070
      inflationRate: 0.020
      retirementIncome: 50000

    constructor: (data) ->
      _.extend(@, data)
      _.defaults(@, properties)

    realRate: =>
      finance.realRateOfReturn(@interestRate, @inflationRate)

    yearsInRetirement: =>
      @planEnd - @retirementAge

    calculateCapitalNeeds: =>
      realMonthlyRate = @realRate() / 12
      monthlyPayments = @retirementIncome / 12
      periods = (@planEnd - @retirementAge) * 12
      finance.presentValueOfAnnuity(monthlyPayments, realMonthlyRate, periods, @legacy)

    calculateRetirementSavings: =>
      realMonthlyRate = @realRate() / 12
      monthlyPayments = @monthlyContribution
      periods = (@retirementAge - @age) * 12
      finance.futureValueOfAnnuity(monthlyPayments, realMonthlyRate, periods, @savings)

    calculateMonthlyContributions: =>
      realMonthlyRate = @realRate() / 12
      periods = (@retirementAge - @age) * 12
      futureValue = @calculateCapitalNeeds()
      @monthlyContribution =
        finance.annuityPaymentFromFutureValue(futureValue, realMonthlyRate, periods, @savings)

    calculateRetirementIncome: =>
      realMonthlyRate = @realRate() / 12
      periods = (@planEnd - @retirementAge) * 12
      presentValue = @calculateRetirementSavings()
      @retirementIncome =
        finance.annuityPaymentFromPresentValue(presentValue, realMonthlyRate, periods, @legacy) * 12

    stringify: =>
      # Strip everything that isn't a function, to give an object with only properties
      values = _.pick @, (value, key) ->
        if not _.isFunction(value)
          return value

      JSON.stringify(values)

  class PlanService
    encode: (plan) =>
      btoa(plan.stringify())

    goTo: (plan, path) =>
      return unless plan
      $location.path(path).search({ data: @encode(plan) })

    createPlan: => new Plan()

    getPlan: (params) =>
      if (data = params.data)?
        if angular.isString(data)
          data = JSON.parse(atob(params.data))
        new Plan(data)
      else
        new Plan()

    newPlan: (values) => new Plan(values)

    save: (plan, cb) =>
      return unless plan
      $location.search({ data: @encode(plan) }).replace()
      cb(plan) if cb

    isReady: (plan) ->
      plan and plan.age? and plan.income? and plan.savings? and
      plan.monthlyContribution? and plan.province? and plan.retirementIncome

    calculatePlanData: (plan) =>
      realMonthlyRate = plan.realRate() / 12
      savingsPeriods = (plan.retirementAge - plan.age) * 12
      retirementPeriods = plan.yearsInRetirement() * 12
      withdrawlAmt = plan.retirementIncome / 12
      depositAmt = plan.monthlyContribution
      data = [0..savingsPeriods + retirementPeriods]
      ageInMonths = plan.age * 12
      for i in data
        year = Math.floor(i / 12)
        if (i is 0)
          data[0] =
            savings : plan.savings
            mutualFund: plan.savings
            fees: 0
            mutualFundFees: 0
            month : ageInMonths
            payments: plan.savings
        else if (i <= savingsPeriods)
          fees = data[i-1].savings/12 *
            (feeSchedule.calculateFeePercentage(data[i-1].savings) + feeSchedule.wealthBarMER)
          mutualFundFees = data[i-1].mutualFund/12 * feeSchedule.mutualFundMER
          data[i] =
            savings : (data[i-1].savings + depositAmt - fees) * (1 + realMonthlyRate)
            mutualFund: (data[i-1].mutualFund + depositAmt - mutualFundFees) * (1 + realMonthlyRate)
            fees: fees
            mutualFundFees: mutualFundFees
            month : i + ageInMonths
            payments: depositAmt
        else
          fees = data[i-1].savings/12 *
            (feeSchedule.calculateFeePercentage(data[i-1].savings) + feeSchedule.wealthBarMER)
          mutualFundFees = data[i-1].mutualFund/12 * feeSchedule.mutualFundMER
          savings = Math.max(0, data[i-1].savings - withdrawlAmt - fees) * (1 + realMonthlyRate)
          mutualFund = Math.max(0, data[i-1].mutualFund - withdrawlAmt - mutualFundFees) *
            (1 + realMonthlyRate)
          data[i] =
            savings : savings
            mutualFund: mutualFund
            month : i + ageInMonths
            payments: -withdrawlAmt
      data

    calculateGoalData: (plan) =>
      realMonthlyRate = plan.realRate() / 12
      savingsPeriods = (plan.retirementAge - plan.age) * 12
      retirementPeriods = plan.yearsInRetirement() * 12
      retirementPayments = plan.retirementIncome / 12
      depositAmt = plan.calculateMonthlyContributions()
      data = [0..savingsPeriods + retirementPeriods - 1]
      for i in data
        if (i is 0)
          data[0] =
            savings : plan.savings
            month : plan.age * 12
        else if (i < savingsPeriods - 1)
          data[i] =
            savings : data[i-1].savings * (1 + realMonthlyRate)  + depositAmt
            month : i + plan.age * 12
        else
          data[i] =
            savings : data[i-1].savings * (1 + realMonthlyRate) - retirementPayments
            month : i + plan.age * 12
      data

    calculateRetirementInfo: (plan) =>
      planData = @calculatePlanData(plan)

      outOfSavings = _.find(planData, (x) -> x.month > (plan.age * 12) and x.savings is 0)

      savings: planData[(plan.retirementAge - plan.age) * 12 - 1]?.savings
      remainingSavings: planData[planData.length - 1].savings
      outOfSavings: outOfSavings
      outOfSavingsYear: Math.floor(outOfSavings.month / 12) if outOfSavings
      legacy: planData[planData.length - 1].savings

  new PlanService()
]
